import axios from "axios";
import { API_URL } from "const/constants";

const base = `${API_URL}/referral-partners`;

const unwrap = (res) => res?.data?.data ?? res?.data ?? null;
const unwrapList = (res) => {
  const data = unwrap(res);
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.content)) return data.content;
  if (Array.isArray(data?.items)) return data.items;
  return [];
};

/** Bonus / campaign offers shown to referral partners. */
export const fetchProgramOffers = () => axios.get(`${base}/program-offers`).then(unwrapList);

export const createProgramOffer = (payload) =>
  axios.post(`${base}/program-offers`, payload).then(unwrap);

export const updateProgramOffer = (id, payload) =>
  axios.put(`${base}/program-offers/${id}`, payload).then(unwrap);

export const deleteProgramOffer = (id) => axios.delete(`${base}/program-offers/${id}`).then(unwrap);

/** Terms & conditions versions partners accept on onboarding / settings. */
export const fetchProgramTerms = () => axios.get(`${base}/terms`).then(unwrapList);

export const createProgramTerms = (payload) => axios.post(`${base}/terms`, payload).then(unwrap);

export const updateProgramTerms = (id, payload) =>
  axios.put(`${base}/terms/${id}`, payload).then(unwrap);

export const deleteProgramTerms = (id) => axios.delete(`${base}/terms/${id}`).then(unwrap);

/** Partner FAQ entries. */
export const fetchProgramFaqs = () => axios.get(`${base}/faqs`).then(unwrapList);

export const createProgramFaq = (payload) => axios.post(`${base}/faqs`, payload).then(unwrap);

export const updateProgramFaq = (id, payload) =>
  axios.put(`${base}/faqs/${id}`, payload).then(unwrap);

export const deleteProgramFaq = (id) => axios.delete(`${base}/faqs/${id}`).then(unwrap);
